import { createLogger } from 'redux-logger';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import accountReducer from 'state/account/account.reducer';
import bidReducer from 'state/bid/bid.reducer';
import dialogReducer from 'state/dialog/dialog.reducer';
import navReducer from 'state/nav/nav.reducer';
import notificationsReducer from 'state/notifications/notifications.reducer';
import propertiesReducer from 'state/properties/properties.reducer';

import accountSaga from 'state/account/account.sagas';
import bidSagas from 'state/bid/bid.sagas';
import propertiesSaga from 'state/properties/properties.sagas';

const logger = createLogger({ collapsed: true });

const sagaMiddleware = createSagaMiddleware();

const sagas = [accountSaga, bidSagas, propertiesSaga];
const reducers = { accountReducer, bidReducer, dialogReducer, navReducer, notificationsReducer, propertiesReducer };

const store = configureStore({
    reducer: combineReducers(reducers),
    middleware: [logger, sagaMiddleware]
});

sagas.map(sagaMiddleware.run);

export default store;
